exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-64ee1ddd] .vc-container{border:none}", ""]);

// exports
